import type {AnimationEvent, ReactElement} from 'react';
import {useState} from 'react';
import type {AnimatedBorderElementProps} from './animated-border-element.types';
import {AnimatedBorderElementType} from './animated-border-element.types';
import styles from './animated-border-element.module.scss';

export function AnimatedBorderElement({
  children,
  elementType = AnimatedBorderElementType.DIV,
  radius = 8,
  width = 4,
  animationDurationMs,
  animationCount,
  ...props
}: AnimatedBorderElementProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Parent = elementType;
  const className = `_position-relative ${styles.animatedBorderContainer} ${props.className ?? ''}`;
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  const OUTER_RADIUS_DIFF = width;
  const shouldSkipAnimation = isAnimationComplete || animationCount === 0;

  const onAnimationEnd = (e: AnimationEvent<HTMLElement>): void => {
    if (typeof props.onAnimationEnd === 'function') {
      props.onAnimationEnd(e);
    }

    setIsAnimationComplete(true);
  };

  return (
    <Parent
      {...props}
      className={className}
      style={{
        borderRadius: radius + OUTER_RADIUS_DIFF,
        padding: width,
        margin: -width,
        ...(shouldSkipAnimation ? {overflow: 'visible', animation: 'none'} : {}),
      }}
      onAnimationEnd={onAnimationEnd}
    >
      {!shouldSkipAnimation ? (
        <div className={styles.animatedBorder} style={{animationDuration: `${animationDurationMs}ms`, animationIterationCount: animationCount}} />
      ) : null}
      <div className={`flexbox bg-neutral-0 ${styles.contentContainer}`} style={{borderRadius: radius}}>
        {children}
      </div>
    </Parent>
  );
}
